import React from "react";
import GridPanel from '../GridPanel';
import PropTypes from "prop-types";
import "./style.css";

export const TreeList = ({items, keys, onItemClick, formatter})=>{
    const treeFormatter = ({row})=>{
        return row [keys.container]?row[keys.title]:<a style={{cursor: "pointer"}} onClick={()=>onItemClick?.(row)}>{row[keys.title]}</a>
    }
    return <GridPanel data={items} options={{
        columns: [
            {name: keys.title, title: keys.title, formatter: formatter || treeFormatter}
        ],
        filtering: true,
        showFilter: true,
        tree: {
            getChildRows: (row, rootRows) => {
                let childRows;
                if (row) {
                    childRows = rootRows .filter(item => item[keys.link] && item[keys.link] === row[keys.id])
                    childRows.forEach(x=>x.parent = row)
                } else {
                    childRows = rootRows.filter(item => !item[keys.link])
                }
                return childRows.length ? childRows : null;
            },
            treeColumnName: keys.title
          },
          hideHeader: true
    }}/>
}

TreeList.propTypes = {
    items: PropTypes.array,
    keys: PropTypes.object,
    onItemClick: PropTypes.func,
    formatter: PropTypes.func
}
